/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateOperationChainMutationRequest,
  CreateOperationChainMutationResponse,
} from "../types/CreateOperationChain.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createOperationChainMutationKey = () =>
  [{ url: "/v1/operation-chain/create-operation-chain" }] as const

export type CreateOperationChainMutationKey = ReturnType<
  typeof createOperationChainMutationKey
>

/**
 * @summary Create an operation chain
 * {@link /v1/operation-chain/create-operation-chain}
 */
export async function createOperationChain(
  data: CreateOperationChainMutationRequest,
  config: Partial<RequestConfig<CreateOperationChainMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateOperationChainMutationResponse,
    ResponseErrorConfig<Error>,
    CreateOperationChainMutationRequest
  >({
    method: "POST",
    url: `/v1/operation-chain/create-operation-chain`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createOperationChainMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateOperationChainMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createOperationChainMutationKey()
  return mutationOptions<
    ResponseConfig<CreateOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createOperationChain(data, config)
    },
  })
}

/**
 * @summary Create an operation chain
 * {@link /v1/operation-chain/create-operation-chain}
 */
export function useCreateOperationChain<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateOperationChainMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateOperationChainMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateOperationChainMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createOperationChainMutationKey()

  const baseOptions = createOperationChainMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateOperationChainMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateOperationChainMutationRequest },
    TContext
  >
}
